import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigData } from "@calaosoft/osapp-common/config/models/ConfigData";
import { SqlDataSource } from "@calaosoft/osapp-common/sqlite/models/sql-data-source";
import { NumberHelper } from "@calaosoft/osapp-common/utils/helpers/numberHelper";
import { FlagService } from "../../../../services/flag.service";
import { SqlRemoteProvider } from "../../../sqlite/services/providers/sql-remote-provider.service";
import { IStockVersionResponse } from "../models/istock-version-response";
import { STOCK_DATABASE_ID } from "../models/stock.constante";

@Injectable()
export class StockRemoteProviderService extends SqlRemoteProvider {
	//#region FIELDS

	protected override readonly C_LOG_ID = "STCK.RMT.PRVDR.S::";

	//#endregion FIELDS

	//#region PROPERTIES

	//#region METHODS

	public constructor(poHttpClient: HttpClient, psvcFlag: FlagService) {
		super(poHttpClient, psvcFlag);
	}

	public override canProcess(psDatabaseId: string): boolean {
		return psDatabaseId.startsWith(STOCK_DATABASE_ID);
	}

	public override getLastUrl(psDatabaseId: string): string {
		return `${this.getUrl(psDatabaseId)}/version`;
	}

	public override getUrl(psDatabaseId: string): string {
		// Sur mobile le databaseId commence par "stock-" mais pas sur mobile. Fix temporaire.
		if (psDatabaseId.indexOf("-") !== -1) return `${this.urlBase}warehouses/${psDatabaseId.split("-")[1]}`;
		else return `${this.urlBase}warehouses/${psDatabaseId}`;
	}

	public override getLastDatabaseAsync(psDatabaseId: string): Promise<SqlDataSource> {
		return this.getRemoteLastVersionAsync(psDatabaseId).then(
			(pnVersion: number) => new SqlDataSource(psDatabaseId, pnVersion, this.getUrl(psDatabaseId))
		);
	}

	private getRemoteLastVersionAsync(psDatabaseId: string): Promise<number> {
		return this.getVersionResponseAsync<IStockVersionResponse>(psDatabaseId)
			.then((poVersionResponse?: IStockVersionResponse) => {
				const lnVersion: number = +(poVersionResponse?.version ?? "");
				return NumberHelper.isValidPositive(lnVersion) ? lnVersion : 0;
			})
			.catch((poError) => {
				console.error(`${this.C_LOG_ID}Getting last version of the stock '${psDatabaseId}' failed.`, poError);
				throw poError;
			});
	}

	protected override createUrlBase(psWorkspace: string): string {
		return `${ConfigData.environment.cloud_url}/api/apps/${ConfigData.appInfo.appId}/workspaces/${psWorkspace}/entities/stocks/`;
	}

	//#endregion METHODS
}
